<template>
  <span class="primary-grey--text font-weight-bold d-flex align-center">
    <v-img
      src="/static/dashboard/svg/grainfox-ai-icon.svg"
      contain
      width="30"
      height="30"
      alt="AI"
      class="mr-2"
    />
    <span class="mr-2">
      Ask
    </span>
    <span
      :style="{ color: COLORS.grainfoxAIButton }"
    >
      Sinoa
    </span>
  </span>
</template>

<script>
import { COLORS } from '@/helpers/colors';

export default {
  name: 'SinoaTitle',

  data() {
    return {
      COLORS,
    };
  },
};
</script>
